module.exports = __webpack_public_path__ + "static/blue_hair-2ea9c4ed2b8fc566ba226900880ac1a1.jpg";